var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "course_train_set" }, [
    _c("div", { staticClass: "course_train_set_head" }, [
      _c("div", { staticClass: "ct goback", on: { click: _vm.goback } }, [
        _c("span", { staticClass: "el-icon-arrow-left" }),
        _vm._v("返回")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "ct" }, [_vm._v(_vm._s(_vm.courseName))]),
      _vm._v(" "),
      _c("span", [
        _c(
          "div",
          { staticClass: "login-user" },
          [
            _c(
              "el-dropdown",
              {
                attrs: { "show-timeout": 0 },
                on: { command: _vm.handleCommand }
              },
              [
                _c("div", { staticClass: "user-name el-dropdown-link" }, [
                  _c("div", { staticClass: "imgBox" }, [
                    _c("img", {
                      attrs: { src: require("../../../static/images/hed0.png") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "login-name" }, [
                    _vm._v(_vm._s(_vm.userName))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c("el-dropdown-item", { attrs: { command: "d" } }, [
                      _vm._v("退出")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "course_train_set_bottom" }, [
      _c(
        "div",
        { staticClass: "course_train_set_tree" },
        [
          _c("new-sidebar", {
            ref: "zlSidebar",
            attrs: {
              courseId: _vm.courseId,
              subjectId: _vm.subjectId,
              newName: "实操"
            },
            on: {
              setStatus: _vm.setStatus,
              clearCatalogName: _vm.clearCatalogName,
              openAddResoures: _vm.openAddResoures,
              emptyCatalogue: _vm.emptyCatalogue,
              handleTreeNodeClick: _vm.handleTreeNodeClick
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.zl_loading,
              expression: "zl_loading"
            }
          ],
          staticClass: "course_train_set_content"
        },
        [
          _vm.status != 3
            ? _c("div", { staticClass: "add_resources_operation" }, [
                _c("div", { staticClass: "catalog_name" }, [
                  _vm._v(_vm._s(_vm.catalogName))
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm.status === 1
                    ? _c(
                        "span",
                        {
                          staticClass: "zl_button zl_blueButton",
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.status = 2
                            }
                          }
                        },
                        [_vm._v("添加")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === 2
                    ? _c(
                        "span",
                        {
                          staticClass: "zl_button zl_whiteButton",
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.resources.length > 0
                                ? (_vm.status = 3)
                                : (_vm.status = 4)
                            }
                          }
                        },
                        [_vm._v("取消")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === 2
                    ? _c(
                        "span",
                        {
                          staticClass: "zl_button zl_blueButton",
                          attrs: { type: "primary", plain: "", size: "mini" },
                          on: { click: _vm.handleSaveTrain }
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.status === 1
            ? _c("div", { staticClass: "btn_wrap" }, [
                _c(
                  "span",
                  {
                    staticClass: "zl_button zl_blueButton",
                    attrs: { plain: "", size: "mini", icon: "el-icon-delete" },
                    nativeOn: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.deleteAll.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("删除")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.status === 1
            ? _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
                _c(
                  "div",
                  { staticClass: "course_train_set_2" },
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.resources,
                          stripe: "",
                          height: "100%",
                          "cell-style": { textAlign: "left", border: "none" },
                          "header-cell-style": { textAlign: "left" }
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", width: "55" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "标题" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.name
                                            ? scope.row.name
                                            : scope.row.tagName + scope.row.id
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            86886763
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "difficulty",
                            label: "难度",
                            width: "150"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.difficulty == 1
                                            ? "简单"
                                            : scope.row.difficulty == 2
                                            ? "中等"
                                            : scope.row.difficulty == 3
                                            ? "困难"
                                            : ""
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1059721540
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "score",
                            label: "建议分数",
                            width: "150"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "200" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.showRow(
                                              scope.row,
                                              scope.$index
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  预览\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.deleteRow(scope.row)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  删除\n                "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2491449328
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "empty_material",
                            attrs: { slot: "empty" },
                            slot: "empty"
                          },
                          [_c("p", [_vm._v("暂无试题")])]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm.status === 2
            ? _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
                _c("div", { staticClass: "course_train_set_3" }, [
                  _c(
                    "div",
                    {
                      class: _vm.showTrigonActive
                        ? "tag_wrap trigonActive"
                        : "tag_wrap"
                    },
                    [
                      _vm._l(_vm.selectResourse, function(tag) {
                        return _c(
                          "el-tag",
                          {
                            key: tag.id,
                            attrs: {
                              "disable-transitions": "",
                              closable: "",
                              type: tag.id + ""
                            },
                            on: {
                              close: function($event) {
                                return _vm.closeTag(tag)
                              }
                            }
                          },
                          [
                            tag.name && tag.name != ""
                              ? [_vm._v(_vm._s(tag.name))]
                              : tag.taskName && tag.taskName != ""
                              ? [_vm._v(_vm._s(tag.taskName))]
                              : tag.content && tag.content != ""
                              ? [
                                  _vm.$delHtmlTag
                                    .delHtmlTag(tag.content)
                                    .substring(0, 10).length >= 10
                                    ? [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$delHtmlTag
                                                .delHtmlTag(tag.content)
                                                .substring(0, 10) + "..."
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$delHtmlTag
                                                .delHtmlTag(tag.content)
                                                .substring(0, 10)
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                ]
                              : tag.questionContent
                              ? [
                                  _vm.$delHtmlTag
                                    .delHtmlTag(tag.questionContent)
                                    .substring(0, 10).length >= 10
                                    ? [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$delHtmlTag
                                                .delHtmlTag(tag.questionContent)
                                                .substring(0, 10) + "..."
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$delHtmlTag
                                                .delHtmlTag(tag.questionContent)
                                                .substring(0, 10)
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "trigon",
                        on: {
                          click: function($event) {
                            _vm.showTrigonActive = !_vm.showTrigonActive
                          }
                        }
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "qst_wrap" },
                    [
                      _c("add-question", {
                        ref: "addQuestion",
                        attrs: {
                          qsType: 2,
                          selectResourse: _vm.selectResourse,
                          isShort: "",
                          checkList: _vm.presentList,
                          resourcesFrom: "1",
                          courseId: _vm.courseId,
                          checkout: "",
                          course: "",
                          subjectId: _vm.subjectId
                        },
                        on: {
                          removeCheck: _vm.removeCheck,
                          getQuestionList: _vm.getQuestionList,
                          selectChange: _vm.selectChange
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm.status === 3
            ? _c("transition", [
                _c("div", { staticClass: "show_content" }, [
                  _c("div", { staticClass: "show_left" }, [
                    _c("div", { staticClass: "add_resources_operation" }, [
                      _vm.status === 3 ? _c("div") : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "question_title" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.catalogName) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.status === 3 ? _c("div") : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cont" }, [
                      _c(
                        "div",
                        {
                          staticClass: "add_resources_operation",
                          staticStyle: { background: "#fff" }
                        },
                        [
                          _c("div", {
                            staticClass: "catalog_name",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.checkCataObj.name
                                  ? _vm.checkCataObj.name
                                  : _vm.$delHtmlTag.delHtmlTag(
                                      _vm.checkCataObj.content
                                    ).length > 40
                                  ? _vm.$delHtmlTag
                                      .delHtmlTag(_vm.checkCataObj.content)
                                      .substring(0, 40) + "..."
                                  : _vm.$delHtmlTag.delHtmlTag(
                                      _vm.checkCataObj.content
                                    )
                              )
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "cont_inner editorShowArea ql-editor",
                        domProps: {
                          innerHTML: _vm._s(_vm.checkCataObj.content)
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "show_right" },
                    [
                      _c("div", { staticClass: "show_title" }, [
                        _c("div", [
                          _vm._v("共计"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "rgba(24, 144, 255, 1)",
                                margin: "0 3px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.resources.length > 0
                                    ? _vm.resources.length
                                    : ""
                                )
                              )
                            ]
                          ),
                          _vm._v("个任务")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "jusitify-content": "center",
                              color: "rgba(24, 144, 255, 1)",
                              cursor: "pointer"
                            },
                            on: { click: _vm.edit }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-edit-outline",
                              staticStyle: { "margin-right": "3px" }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: { color: "rgba(24, 144, 255, 1)" }
                              },
                              [_vm._v("编辑")]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          staticClass: "syllable_ul",
                          attrs: {
                            element: "ul",
                            list: _vm.resources,
                            animation: "500",
                            "no-transition-on-drag": true,
                            move: _vm.move
                          },
                          on: {
                            change: _vm.change,
                            start: _vm.start,
                            end: _vm.end
                          }
                        },
                        [
                          _c(
                            "transition-group",
                            {
                              attrs: {
                                type: "transition",
                                name: !_vm.drag ? "syll_li" : null,
                                css: true
                              }
                            },
                            _vm._l(_vm.resources, function(item, index) {
                              return _c(
                                "li",
                                {
                                  key: item.id,
                                  class:
                                    index == _vm.checkCataIndex ? "active" : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.getCheckInfo(index)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "syllable_img" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("任务" + _vm._s(index + 1))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "cont editorShowArea ql-editor",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        item.name
                                          ? item.name
                                          : _vm.$delHtmlTag.delHtmlTag(
                                              item.content
                                            )
                                      )
                                    }
                                  })
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            : _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
                _c("div", { staticClass: "course_train_set_0" }, [
                  _c("div", { staticClass: "course_train_set_c" }, [
                    _c("img", {
                      staticStyle: {
                        width: "187px",
                        height: "159px",
                        "margin-bottom": "20px"
                      },
                      attrs: {
                        src: require("../../../src/assets/image/sources/table_no_data.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _vm.status === 0
                      ? _c("p", { staticStyle: { "text-align": "center" } }, [
                          _vm._v("一级目录下不能编辑内容")
                        ])
                      : _vm.status === 5
                      ? _c("p", { staticStyle: { "text-align": "center" } }, [
                          _vm._v("请在末级目录下编辑内容")
                        ])
                      : _vm.status === 4
                      ? _c("p", [
                          _vm._v("暂无内容,请"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                color: "#1890FF"
                              },
                              on: { click: _vm.addShixun }
                            },
                            [_vm._v("添加实训")]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b338e38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b338e38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/course_train_set/index.vue
// module id = null
// module chunks = 